import type { EMessageChannel } from 'src/services/api/messages/types';
import {
    composerText,
    snippetIdForSend,
    type ComposerState,
} from 'src/pages/landlord/leads/messages/context/composer-state';
import { OUTBOUND_TRANSLATABLE_LANGS } from 'src/pages/landlord/leads/messages/utils/detect-lead-language';

export type ComposerSendCommand = {
    conversationId: string;
    channel: EMessageChannel;
    message: string;
    attachments?: File[];
    snippetId?: number;
    translateToLang?: string;
};

type DecideComposerSendCommandArgs = {
    state: ComposerState;
    channel: EMessageChannel;
    files?: readonly File[];
    detectedLeadLang: string | null;
    isTranslateOutboundEnabled: boolean | null;
};

/** Pure decision step for one captured send operation. */
export const decideComposerSendCommand = ({
    state,
    channel,
    files,
    detectedLeadLang,
    isTranslateOutboundEnabled,
}: DecideComposerSendCommandArgs): ComposerSendCommand => {
    const shouldTranslate =
        isTranslateOutboundEnabled === true &&
        !!detectedLeadLang &&
        OUTBOUND_TRANSLATABLE_LANGS.has(detectedLeadLang);

    return {
        conversationId: state.conversationId,
        channel,
        message: composerText(state),
        attachments: files ? [...files] : undefined,
        snippetId: snippetIdForSend(state),
        translateToLang: shouldTranslate ? detectedLeadLang : undefined,
    };
};
